import { render, staticRenderFns } from "./S3Album.vue?vue&type=template&id=759cb30a&scoped=true&"
import script from "./S3Album.vue?vue&type=script&lang=js&"
export * from "./S3Album.vue?vue&type=script&lang=js&"
import style0 from "./S3Album.vue?vue&type=style&index=0&id=759cb30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759cb30a",
  null
  
)

export default component.exports